<template>
  <div id="Youtube" v-if="this.userData.data.username == 'admin'">
    <!-- <Breadcrumb :list="list"/> -->
    <div v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap card top-card">
      <div class="left-card">
        <div style="min-width: 17%">
          <select v-model="selected_website" class="form-control customSelect text-uppercase">
            <optgroup label="Retail">
              <option value="all">All</option>
              <option value="https://www.amazon.com">Amazon US</option>
              <option value="https://www.amazon.fr">Amazon France</option>
              <option value="https://www.amazon.co.it">Amazon Italy</option>
              <option value="https://www.amazon.es">Amazon Spain</option>
              <option value="https://www.amazon.co.uk">Amazon UK</option>
              <option value="https://www.amazon.de">Amazon Germany</option>
              <option value="https://www.bestbuy.com">Best Buy US</option>
              <option value="https://www.newegg.com">Newegg</option>
              <option value="https://www.microcenter.com">Microcenter</option>
              <option value="https://www.costco.com">Costco US</option>
              <option value="https://www.currys.co.uk">Curry's UK</option>
              <option value="https://www.harveynorman.com.au">Harvey Norman AU</option>
              <option value="https://global.jd.com">JD GC</option>
              <option value="https://www.mediamarkt.de">MediaMarkt DE</option>
              <option value="https://www.walmart.com">Walmart US</option>
            </optgroup>
            <optgroup label="Consumer OEM">
              <option value="https://br-store.acer.com">Acer Brazil</option>
              <option value="https://store.acer.com/en-us">Acer US</option>
              <option value="https://www.asus.com/fr">ASUS France</option>
              <option value="https://store.asus.com/us">ASUS US</option>
              <option value="https://www.asus.com">ASUS WW</option>
              <option value="https://www.dell.com/en-au">Dell Australia</option>
              <option value="https://www.dell.com/ja-jp">Dell Japan</option>
              <option value="https://www.dell.com/en-us">Dell US</option>
              <option value="https://www.dell.com/en-uk">Dell UK</option>
              <option value="https://fmv.fccl.fujitsu.com">Fujitsu Japan</option>
              <option value="https://store.hp.com/FranceStore">HP France</option>
              <option value="https://www8.hp.com/jp">HP Japan</option>
              <option value="https://store.hp.com/mx-es">HP Mexico</option>
              <option value="https://store.hp.com/UKStore">HP UK</option>
              <option value="https://store.hp.com/us">HP US</option>
              <option value="https://www.lenovo.com/au">Lenovo Australia</option>
              <option value="https://s.lenovo.com.cn">Lenovo China</option>
              <option value="https://www.lenovo.com/fr">Lenovo France</option>
              <option value="https://www.lenovo.com/de">Lenovo Germany</option>
              <option value="https://www.lenovo.com/gb">Lenovo UK</option>
              <option value="https://www.lenovo.com/us">Lenovo US</option>
              <option value="https://www.nec-lavie.jp">NEC Japan</option>
            </optgroup>
            <optgroup label="Commercial OEM">
              <option value="https://www.hpstore.cn#commercial">
                Commercial HP China
              </option>
              <option value="https://store.hp.com/FranceStore#commercial">
                Commercial HP France
              </option>
              <option value="https://store.hp.com/GermanyStore#commercial">
                Commercial HP Germany
              </option>
              <option value="https://www8.hp.com/jp#commercial">
                Commercial HP Japan
              </option>
              <option value="https://store.hp.com/UKStore#commercial">
                Commercial HP UK
              </option>
              <option value="https://store.hp.com/us#commercial">Commercial HP US</option>
              <option value="https://b2b.lenovo.com.cn#commercial">
                Commercial Lenovo China
              </option>
              <option value="https://www.lenovo.com/fr#commercial">
                Commercial Lenovo France
              </option>
              <option value="https://www.lenovo.com/de#commercial">
                Commercial Lenovo Germany
              </option>
              <option value="https://www.lenovo.com/jp#commercial">
                Commercial Lenovo Japan
              </option>
              <option value="https://www.lenovo.com/gb#commercial">
                Commercial Lenovo UK
              </option>
              <option value="https://www.lenovo.com/us#commercial">
                Commercial Lenovo US
              </option>
            </optgroup>
            <optgroup label="Commercial Reseller">
              <option value="https://www.bechtle.com">Bechtle</option>
              <option value="https://www.cdw.com">CDW</option>
              <option value="https://www.inmac-wstore.com">Inmac</option>
              <option value="https://www.insight.com/en-US">Insight</option>
              <option value="https://www.connection.com">PC Connection</option>
              <option value="https://www.shi.com">SHI</option>
              <option value="https://www.technoworld.com">TechnoWorld</option>
              <option value="https://www.dustin.no">Dustin Nordics Norway</option>
              <option value="https://www.dustin.se">Dustin Nordics Sweden</option>
              <option value="https://www.dustin.fi">Dustin Nordics Finland</option>
              <option value="https://www.dustin.dk">Dustin Nordics Denmark</option>
            </optgroup>
            <!-- <optgroup label="Demo Automation">
              <option ></option>
            </optgroup> -->
            <optgroup label="Ecommerce India Scrappers">
              <option value="https://www.swiggy.com">Swiggy</option>
              <option value="https://bigbasket.com">Bigbasket</option>
              <option value="https://blinkit.com">Blinkit</option>
            </optgroup>
          </select>
        </div>
        <!-- <div class="datebox">
          <select v-model="device" @change="refresh"  class="form-control text-uppercase">
            <option value="laptop">Laptop PC</option>
            <option value="desktop">Desktop</option>
          </select>
        </div>  -->
        <div>
          <button @click="refresh" class="btn btn-block primarycolor">Submit</button>
        </div>
      </div>
      <button @click="showForm = true" class="primarycolor addbtn">
        Add Spider/Dump
      </button>
    </div>

    <div class="card mx-2">
      <div class="mt-3" style="color: var(--primary_brand); font-weight: 800; font-family: 'Poppins';">
        <h3 class="mb-2">Spider Details</h3>
      </div>
      <div style="padding: 16px; overflow-x: auto">
        <table class="rounded-corners w-100">
          <thead>
            <tr>
              <th style="min-width: 120px; font-size: 15px;" class="py-3" v-for="head in spiderTableData.header"
                :key="head.value">
                {{ head.key }} <span v-if="head.value == 'time'">(24 hours)</span>
              </th>
              <th style="font-size: 15px;" class="py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in spiderTableData.data" :key="d.spider_name">
              <td style="font-size: 14px;" class="p-2" v-for="head in spiderTableData.header">
                <div style="margin: 0; display: flex; justify-content: center" v-if="head.value === 'email_id'">
                  <div v-if="!d[head.value].length" class="alert alert-warning">
                    No Email ID Found
                  </div>
                  <b-row style="margin: 0">
                    <b-col md="*" v-for="email in d[head.value]" :key="'spiderEmail' + email">
                      <div class="badge badge-pill badge-primary">
                        {{ email }}
                        <i @click="deleteSpiderEmail(email, d.spider_name)" class="fa fa-times"
                          style="cursor: pointer"></i>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <span v-else>{{ d[head.value] }}</span>
              </td>
              <td>
                <button type="button" class="edit-buttons" @click="getSpiderDetailData(d.spider_name)">
                  <i class="fa fa-edit text-primary"></i>
                </button>
                <button type="button" class="edit-buttons ml-2" @click="deleteSpiderDumpRow(d.spider_name, 'spider')">
                  <i class="fa fa-trash text-danger"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-3" style="color: var(--primary_brand); font-weight: 800; font-family: 'Poppins';">
        <h3 class="mb-2">Dump Details</h3>
      </div>
      <div style="padding: 16px; overflow-x: auto">
        <table class="rounded-corners w-100">
          <thead>
            <tr>
              <th style="min-width: 120px; font-size: 15px;" v-for="head in dumpTableData.header" :key="head.value"
                class="py-3">
                {{ head.key }} <span v-if="head.value == 'time'">(24 hours)</span>
              </th>
              <th style="font-size: 15px;" class="py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in dumpTableData.data" :key="d.tasks">
              <td style="font-size: 14px;" class="p-2" v-for="head in dumpTableData.header">
                <div style="margin: 0; display: flex; justify-content: center" v-if="head.value === 'translate_fields'">
                  <b-row style="margin: 0">
                    <b-col md="*" v-for="val in d[head.value]" style="padding: 3px" :key="'value' + val">
                      <div class="badge badge-pill badge-primary">
                        {{ covertKebabCase(val) }}
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <span v-else>{{ d[head.value] }}</span>
              </td>
              <td>
                <button type="button" class="edit-buttons" @click="getDumpDetailData(d.tasks)">
                  <i class="fa fa-edit text-primary"></i>
                </button>
                <button type="button" class="edit-buttons ml-2" @click="deleteSpiderDumpRow(d.tasks, 'dump')">
                  <i class="fa fa-trash text-danger"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal size="lg" hide-footer title="Add Spider/Dump" v-model="showForm" @hidden="resetForm()" ref="schedule-form">
      <div id="spiderInfo">
        <b-card>
          <div class="pl-5 pt-2">
            <div class="form-group row pb-2">
              <label for="taskCustomSelect" class="col-sm-3 col-form-label">Schedule</label>
              <div class="col-sm-7">
                <select class="custom-select" id="taskCustomSelect" v-model="formData.scheduleType">
                  <option value="schedule_spider">SCHEDULE SPIDER</option>
                  <option value="schedule_dump">SCHEDULE DUMP</option>
                  <option value="schedule_local">LOCAL SPIDER</option>
                </select>
              </div>
            </div>

            <div>
              <div class="form-group row" v-if="formData.scheduleType !== 'schedule_local'">
                <label class="col-sm-3 col-form-label">Time <span>(24 hours)</span><span>*</span></label>
                <div class="col-sm-7">
                  <!-- <input class="form-control" type="time" step="1" placeholder="time" > -->
                  <vue-timepicker manual-input format="HH:mm" v-model="formData.time"></vue-timepicker>
                </div>
              </div>
              <div class="form-group row"
                v-if="(formData.scheduleType == 'schedule_spider') || (formData.scheduleType == 'schedule_local')">
                <label class="col-sm-3 col-form-label">Spider Name<span>*</span></label>
                <div class="col-sm-7">
                  <input class="form-control" type="text" step="1" placeholder="ENTER SPIDER NAME"
                    v-model="formData.spiderName" />
                </div>
              </div>
              <div class="form-group row" v-if="formData.scheduleType == 'schedule_dump'">
                <label for="taskCustomSelect" class="col-sm-3 col-form-label">Task<span>*</span></label>
                <div class="col-sm-7">
                  <select class="custom-select" id="taskCustomSelect" v-model="formData.task">
                    <option value="" disabled hidden>SELECT TASK</option>
                    <option value="dump_SOS_to_ES">DUMP SOS TO ES</option>
                    <option value="dump_SOVDetails_to_ES">DUMP SOV DETAILS TO ES</option>
                    <option value="dump_SOV_to_ES">DUMP SOV TO ES</option>
                    <option value="dump_category_to_ES">DUMP CATEGORY TO ES</option>
                    <option value="dump_price_to_ES">DUMP PRICE TO ES</option>
                    <option value="dump_websitedata_to_ES">
                      DUMP WEBSITE DATA TO ES
                    </option>
                    <option value="translate_category">TRANSLATE CATEGORY</option>
                    <option value="translate_sov_details">TRANSLATE SOV DETAILS</option>
                    <option value="dump_pincode_availability_to_ES">DUMP PINCODE AVAILABILITY TO ES</option>
                  </select>
                </div>
              </div>
              <div class="form-group row" v-if="formData.scheduleType == 'schedule_dump' &&
                (formData.task == 'translate_category' ||
                  formData.task == 'translate_sov_details')
                ">
                <label for="fieldsCustomSelect" class="col-sm-3 col-form-label">Fields<span>*</span></label>
                <div class="col-7">
                  <multiselect v-model="formData.fieldData" placeholder="SELECT FIELDS" label="name" track-by="code"
                    :options="fieldMultiSelectOptions" :multiple="true" :searchable="false"></multiselect>
                </div>
              </div>
              <div class="form-group row pb-2"
                v-if="formData.scheduleType == 'schedule_spider' || formData.scheduleType == 'schedule_dump'">
                <label for="projectSelect" class="col-sm-3 col-form-label">Project*</label>
                <div class="col-sm-7">
                  <select class="custom-select" id="projectSelect" v-model="formData.projectType">
                    <option value="ecommerce_scrapy">E-COMMERCE SCRAPY</option>
                    <option value="url_finder">COMPLIANCE</option>
                    <option value="ecom_india">E-COM INDIA</option>
                    <option value="demo_automation">DEMO AUTOMATION</option>
                  </select>
                </div>
              </div>
              <div class="form-group row"
                v-if="(formData.scheduleType == 'schedule_spider' && (formData.projectType !== 'url_finder' && formData.projectType !== 'ecom_india')) || (formData.scheduleType == 'schedule_local') || (formData.scheduleType == 'schedule_dump')">
                <label for="indexCustomSelect" class="col-sm-3 col-form-label">Index<span>*</span></label>
                <div class="col-sm-7">
                  <select class="custom-select" id="indexCustomSelect" v-model="formData.index">
                    <option value="" disabled hidden>SELECT INDEX</option>
                    <option value="results">RESULTS</option>
                    <option value="retail_price">RETAIL PRICE</option>
                    <option value="sos">SOS</option>
                    <option value="sov">SOV</option>
                    <option value="sov_details">SOV DETAILS</option>
                    <option value="websiteresult">WEBSITE RESULTS</option>
                    <option value="pincode_tracking">PINCODE TRACKING</option>
                    <option value="compliance" v-if="formData.scheduleType == 'schedule_local'">COMPLIANCE</option>
                    <option value="reviews" v-if="formData.scheduleType == 'schedule_local'">REVIEWS</option>

                  </select>
                </div>
              </div>
              <div class="form-group row"
                v-if="(formData.scheduleType == 'schedule_spider' && (formData.projectType !== 'url_finder' && formData.projectType !== 'ecom_india')) || (formData.scheduleType == 'schedule_local')">
                <label for="segmentCustomSelect" class="col-sm-3 col-form-label">Segment</label>
                <div class="col-sm-7">
                  <select class="custom-select" id="segmentCustomSelect" v-model="formData.segment">
                    <option value="" disabled hidden>SELECT SEGMENT</option>
                    <option value="explore">EXPLORE</option>
                    <option value="shop">SHOP</option>
                    <option value="None">NONE</option>
                  </select>
                </div>
              </div>
              <div class="form-group row"
                v-if="(formData.scheduleType == 'schedule_spider' && (formData.projectType !== 'url_finder' && formData.projectType !== 'ecom_india')) || (formData.scheduleType == 'schedule_local')">
                <label for="indexCustomSelect" class="col-sm-3 col-form-label">Item Category</label>
                <div class="col-sm-7">
                  <select class="custom-select" id="indexCustomSelect" v-model="formData.item_category">
                    <option value="" disabled hidden>SELECT ITEM CATEGORY</option>
                    <option value="laptop">LAPTOP</option>
                    <option value="desktop">DESKTOP</option>
                    <option value="neither">NEITHER</option>
                    <option value="cpu">CPU</option>
                    <option value="gpu">GPU</option>
                    <option value="None">ALL</option>
                  </select>
                </div>
              </div>

              <div class="row"
                v-if="(formData.scheduleType == 'schedule_spider') || (formData.scheduleType == 'schedule_local')">
                <div class="col-sm-3">Email<span>*</span></div>
                <div class="col-sm-7">
                  <input type="text" class="form-control" id="inputEmail" placeholder="ADD EMAILS"
                    @keyup.enter="addFormEmailValues()" v-model="formData.newEmail" />
                </div>
                <button @click="addFormEmailValues()" class="btn primarycolor">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
              <div class="mt-1 mb-4" style="margin-left: 25%">
                <b-badge variant="success" class="mr-1 mt-2 ml-2 asinBadge p-1" v-for="(mail, i) in formData.email_list"
                  :key="mail">
                  <span>{{ mail }}</span>
                  <b-badge variant="success" @click="removeFormEmail(i)" class="ml-1 mb-5 crossIcon"
                    title="remove">x</b-badge>
                </b-badge>
              </div>
              <div style="margin-top: 10px; display: flex; justify-content: center" @click="submitNewSpiderForm()">
                <button class="btn btn-block btn-primary primarycolor col-4">Submit</button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </b-modal>

    <b-modal size="lg" hide-footer :title="spiderConfigFormData.spiderName" v-model="showSpiderConfigForm" centered>
      <div id="spiderInfo">
        <b-card>
          <div class="pl-5 pt-2">
            <div class="form-group row" v-if="spiderConfigFormData.task == 'schedule_spider'">
              <label class="col-sm-3 col-form-label">Time <span>(24 hours)</span></label>
              <div class="col-sm-7">
                <!-- <input class="form-control" type="time" step="1" placeholder="time" > -->
                <vue-timepicker manual-input format="HH:mm" v-model="spiderConfigFormData.time"></vue-timepicker>
              </div>
            </div>
            <div class="form-group row pb-2" v-if="spiderConfigFormData.task == 'schedule_spider'">
              <label for="projectConfigSelect" class="col-sm-3 col-form-label">Project*</label>
              <div class="col-sm-7">
                <select class="custom-select" id="projectConfigSelect" v-model="spiderConfigFormData.projectType">
                  <option value="ecommerce_scrapy">E-COMMERCE SCRAPY</option>
                  <option value="url_finder">COMPLIANCE</option>
                  <option value="ecom_india">E-COM INDIA</option>
                  <option value="demo_automation">DEMO AUTOMATION</option>
                </select>
              </div>
            </div>
            <div class="form-group row"
              v-if="(spiderConfigFormData.task == 'schedule_spider' && (spiderConfigFormData.projectType !== 'url_finder' && spiderConfigFormData.projectType !== 'ecom_india')) || (spiderConfigFormData.task == 'local_spider')">
              <label for="indexCustomSelect" class="col-sm-3 col-form-label">Index</label>
              <div class="col-sm-7">
                <select class="custom-select" id="indexCustomSelect" v-model="spiderConfigFormData.index">
                  <option value="" disabled hidden>SELECT INDEX</option>
                  <option value="results">RESULTS</option>
                  <option value="retail_price">RETAIL PRICE</option>
                  <option value="sos">SOS</option>
                  <option value="sov">SOV</option>
                  <option value="sov_details">SOV DETAILS</option>
                  <option value="websiteresult">WEBSITE RESULTS</option>
                  <option value="compliance" v-if="spiderConfigFormData.task == 'local_spider'">COMPLIANCE</option>
                  <option value="reviews" v-if="spiderConfigFormData.task == 'local_spider'">REVIEWS</option>
                  <option value="pincode_tracking">PINCODE TRACKING</option>
                </select>
              </div>
            </div>
            <div class="form-group row"
              v-if="(spiderConfigFormData.task == 'schedule_spider' && (spiderConfigFormData.projectType !== 'url_finder' && spiderConfigFormData.projectType !== 'ecom_india')) || (spiderConfigFormData.task == 'local_spider')">
              <label for="segmentCustomSelect" class="col-sm-3 col-form-label">Segment</label>
              <div class="col-sm-7">
                <select class="custom-select" id="segmentCustomSelect" v-model="spiderConfigFormData.segment">
                  <option value="" disabled hidden>SELECT SEGMENT</option>
                  <option value="explore">EXPLORE</option>
                  <option value="shop">SHOP</option>
                  <option value="None">NONE</option>
                </select>
              </div>
            </div>
            <div class="form-group row"
              v-if="(spiderConfigFormData.task == 'schedule_spider' && (spiderConfigFormData.projectType !== 'url_finder' && spiderConfigFormData.projectType !== 'ecom_india')) || (spiderConfigFormData.task == 'local_spider')">
              <label for="indexCustomSelect" class="col-sm-3 col-form-label">Item Category</label>
              <div class="col-sm-7">
                <select class="custom-select" id="indexCustomSelect" v-model="spiderConfigFormData.itemCategory">
                  <option value="" disabled hidden>SELECT ITEM CATEGORY</option>
                  <option value="laptop">LAPTOP</option>
                  <option value="desktop">DESKTOP</option>
                  <option value="neither">NEITHER</option>
                  <option value="cpu">CPU</option>
                  <option value="gpu">GPU</option>
                  <option value="None">ALL</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">Email</div>
              <div class="col-sm-7">
                <input type="text" class="form-control" id="inputEmail" placeholder="ADD EMAILS"
                  @keyup.enter="addFormEmailValues()" v-model="spiderConfigFormData.newEmail" />
              </div>
              <button @click="addFormEmailValues()" class="btn primarycolor">
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <div class="mt-1 mb-4 w-50" style="margin-left: 25%">
              <b-badge variant="success" class="mr-1 mt-2 ml-2 asinBadge p-1"
                v-for="(mail, i) in spiderConfigFormData.emailIDs" :key="mail">
                <span>{{ mail }}</span>
                <b-badge variant="success" @click="removeFormEmail(i)" class="ml-1 mb-5 crossIcon"
                  title="remove">x</b-badge>
              </b-badge>
            </div>
          </div>
          <div style="margin-top: 10px; display: flex; justify-content: center" @click="submitSpiderConfigForm()">
            <button class="btn btn-block btn-primary primarycolor col-4">Submit</button>
          </div>
        </b-card>
      </div>
    </b-modal>
    <b-modal size="lg" hide-footer :title="dumpConfigFormData.task" v-model="showDumpConfigForm" @hidden="resetForm()"
      centered>
      <div id="spiderInfo">
        <b-card>
          <div class="pl-5 pt-2">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Time <span>(24 hours)</span></label>
              <div class="col-sm-7">
                <vue-timepicker manual-input format="HH:mm" v-model="dumpConfigFormData.time"></vue-timepicker>
              </div>
            </div>
            <div class="form-group row pb-2">
              <label for="projectConfigSelect" class="col-sm-3 col-form-label">Project*</label>
              <div class="col-sm-7">
                <select class="custom-select" id="projectConfigSelect" v-model="dumpConfigFormData.projectType">
                  <option value="ecommerce_scrapy">E-COMMERCE SCRAPY</option>
                  <option value="url_finder">COMPLIANCE</option>
                  <option value="ecom_india">E-COM INDIA</option>
                  <option value="demo_automation">DEMO AUTOMATION</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="dumpConfigFormData.task != 'translate_sov_details' &&
              dumpConfigFormData.task != 'translate_category'
              ">
              <label for="indexCustomSelect" class="col-sm-3 col-form-label">Index</label>
              <div class="col-sm-7">
                <select class="custom-select" id="indexCustomSelect" v-model="dumpConfigFormData.index">
                  <option value="" disabled hidden>SELECT INDEX</option>
                  <option value="results">RESULTS</option>
                  <option value="retail_price">RETAIL PRICE</option>
                  <option value="sos">SOS</option>
                  <option value="sov">SOV</option>
                  <option value="sov_details">SOV DETAILS</option>
                  <option value="websiteresult">WEBSITE RESULTS</option>
                  <option value="pincode_tracking">PINCODE TRACKING</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="dumpConfigFormData.task == 'translate_sov_details' ||
              dumpConfigFormData.task == 'translate_category'
              ">
              <label for="fieldsCustomSelect" class="col-sm-3 col-form-label">Fields</label>
              <div class="col-sm-7">
                <multiselect v-model="dumpConfigFormData.translateFields" placeholder="SELECT FIELDS" label="name"
                  track-by="code" :options="fieldMultiSelectOptions" :multiple="true" :searchable="false"></multiselect>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px; display: flex; justify-content: center" @click="submitDumpConfigForm()">
            <button class="btn btn-block btn-primary primarycolor col-4">Submit</button>
          </div>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import Multiselect from "vue-multiselect";
import "vue2-timepicker/dist/VueTimepicker.css";
import { all } from "q";
import Loader from "../Components/Loader.vue";

export default {
  name: "AdminDashboard",
  components: {
    Datepicker,
    VueTimepicker,
    Multiselect,
    Loader
  },

  data: function () {
    return {
      moment: moment,
      userData: JSON.parse(localStorage.getItem("reviewUserData")),
      customData: JSON.parse(localStorage.getItem("reviewCustomData")),
      loader: false,
      selected_website: "https://www.harveynorman.com.au",
      date: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      spiderTextNew: "",
      spiderData: [],
      newEmailSpider: {},
      showForm: false,
      showSpiderConfigForm: false,
      showDumpConfigForm: false,
      spiderTableData: {
        header: [],
        data: [],
      },
      dumpTableData: {
        header: [],
        data: [],
      },
      selectedSpider: "",
      fieldMultiSelectOptions: [
        { name: "GPU", code: "gpu" },
        { name: "GPU TYPE", code: "gpu_type" },
        { name: "PROCESSOR", code: "processor" },
        { name: "PROCESSOR TYPE", code: "processor_type" },
        { name: "PRODUCT NAME", code: "product_name" },
        { name: "LOCATION", code: "location" },
      ],
      formData: {
        website: "",
        scheduleType: "schedule_spider",
        spiderName: "",
        time: "00:00:00",
        projectType: "ecommerce_scrapy",
        task: "",
        index: "",
        fieldData: [],
        segment: "",
        item_category: "",
        newEmail: "",
        email_list: [],
      },
      spiderConfigFormData: {
        itemCategory: "",
        time: "00:00:00",
        projectType: 'ecommerce_scrapy',
        website: "",
        segment: "",
        translateFields: [],
        emailIDs: [],
        index: "",
        spiderName: "",
        task: "",
        newEmail: "",
      },
      dumpConfigFormData: {
        task: "",
        time: "00:00:00",
        translateFields: [],
        index: "",
        projectType: ""
      },
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    resetForm() {
      this.formData = {
        scheduleType: "schedule_spider",
        website: "",
        spiderName: "",
        time: "00:00:00",
        task: "",
        index: "",
        fieldData: [],
        fieldMultiSelectOptions: [
          { name: "Gpu", code: "gpu" },
          { name: "Gpu Type", code: "gpu_type" },
          { name: "Processor", code: "processor" },
          { name: "Processor Type", code: "processor_type" },
          { name: "Product Name", code: "product_name" },
          { name: "Location", code: "location" },
        ],
        segment: "",
        item_category: "",
        email: "",
        email_list: [],
        projectType: "ecommerce_scrapy"
      };

      this.dumpConfigFormData = {
        task: "",
        time: "00:00:00",
        translateFields: [],
        index: "",
        projectType: ""
      };
    },
    addFormEmailValues() {
      if (this.showSpiderConfigForm) {
        if (!this.validateEmail(this.spiderConfigFormData.newEmail)) {
          this.$bvToast.toast(`Invalid Email Address!!`, {
            autoHideDelay: 5000,
            variant: "danger",
          });
          return false;
        }
        this.spiderConfigFormData.emailIDs.push(this.spiderConfigFormData.newEmail);
        this.spiderConfigFormData.newEmail = "";
      } else if (this.showForm) {
        if (!this.validateEmail(this.formData.newEmail)) {
          this.$bvToast.toast(`Invalid Email Address!!`, {
            autoHideDelay: 5000,
            variant: "danger",
          });
          return false;
        }
        this.formData.email_list.push(this.formData.newEmail);
        this.formData.newEmail = "";
      }
    },
    removeFormEmail(i) {
      if (this.showSpiderConfigForm) this.spiderConfigFormData.emailIDs.splice(i, 1);
      if (this.showForm) this.formData.email_list.splice(i, 1);
    },
    deleteSpiderDumpRow(name, check) {
      const url = "/api/spider/deletedetails";
      let payload;
      if (check == "spider") {
        payload = {
          check: check,
          spider_name: name,
        };
      } else if (check == "dump") {
        payload = {
          check: check,
          website: this.selected_website,
          task: name,
        };
      }

      if (confirm(`Do you really wish to delete ${name} ??`)) {
        this.$http.post(url, payload).then(
          (response) => {
            this.$bvToast.toast(`${response.data.data.msg}`, {
              autoHideDelay: 5000,
              variant: "danger",
            });
            this.$nextTick(() => {
              this.refresh();
            });
          },
          (err) => {
            console.log(err);
          }
        );
      }
    },

    getWebsiteDetailData() {
      this.loader = true;
      const url = "/api/spider/websitedetail";
      const payload = {
        website: this.selected_website,
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.loader = false;
          const allData = response.data.data;
          if (!Object.keys(allData).length) {
            console.error("no spider data available");
            this.$bvToast.toast(`no spider data available!!`, {
              autoHideDelay: 5000,
              variant: "danger",
            });
            return false;
          }
          const spiderTableData = allData.spider_data;
          const spiderTableHeader = allData.header;
          const dumpTableData = allData.dump_data;
          const dumpTableHeader = allData.dump_header;

          dumpTableData.forEach((data) => {
            data.time = moment(data.time, "HH:mm").format("HH:mm");
          });
          spiderTableData.forEach((data) => {
            data.time = moment(data.time, "HH:mm").format("HH:mm");
          });

          this.spiderTableData.data = spiderTableData;
          this.spiderTableData.header = spiderTableHeader;
          this.dumpTableData.header = dumpTableHeader;
          this.dumpTableData.data = dumpTableData;
        },
        (err) => {
          this.loader = false;
          (this.spiderTableData = {
            header: [],
            data: [],
          }),
            (this.dumpTableData = {
              header: [],
              data: [],
            }),
            console.log(err);
        }
      );
    },
    getSpiderDetailData(spider_name) {
      const url = `/api/spider/spiderdetail?spider_name=${spider_name}`;
      this.$http.get(url).then(
        (response) => {
          const Data = response.body.data.data;
          if (response.body.success === true) {
            this.spiderConfigFormData.itemCategory = Data.item_category;
            this.spiderConfigFormData.time = moment(Data.time, "HH:mm").format(
              "HH:mm:ss"
            );
            this.spiderConfigFormData.website = Data.website;
            this.spiderConfigFormData.translateFields = Data.translate_fields;
            this.spiderConfigFormData.emailIDs = Data.email_id;
            this.spiderConfigFormData.index = Data.index;
            this.spiderConfigFormData.spiderName = Data.spider_name;
            this.spiderConfigFormData.task = Data.task;
            this.spiderConfigFormData.segment = Data.segment;
            if (this.spiderConfigFormData.task === 'schedule_spider') this.spiderConfigFormData.projectType = Data.project;

            this.$nextTick(() => {
              this.showSpiderConfigForm = true;
            });
          } else {
            this.$bvToast.toast(`Some Error Fetching Data`, {
              autoHideDelay: 5000,
              variant: "danger",
            });
          }
        },
        (err) => {
          console.log(err);
          this.$bvToast.toast(`${err}`, {
            autoHideDelay: 5000,
            variant: "danger",
          });
        }
      );
    },
    getDumpDetailData(task_type) {
      const url = "/api/spider/dumpdetails";
      const payload = {
        task: task_type,
        website: this.selected_website,
      };
      this.$http.post(url, payload).then(
        (response) => {
          const dumpData = response.body.data;
          this.dumpConfigFormData.index = dumpData.index;
          this.dumpConfigFormData.task = dumpData.task;
          this.dumpConfigFormData.time = moment(dumpData.time, "HH:mm").format("HH:mm");
          this.dumpConfigFormData.projectType = dumpData.project;
          this.fieldMultiSelectOptions.forEach((option) => {
            if (dumpData.translate_fields.includes(option.code))
              this.dumpConfigFormData.translateFields.push(option);
          });
          this.$nextTick(() => {
            this.showDumpConfigForm = true;
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },
    submitNewSpiderForm() {
      const url = "/api/spider/addspiderscheduling";
      let payload;
      if (
        this.formData.scheduleType == "schedule_spider" &&
        this.formData.spiderName &&
        this.formData.time !== "00:00:00" &&
        (this.formData.projectType === 'url_finder' || this.formData.projectType === 'ecom_india') &&
        // this.formData.index &&
        // this.formData.segment &&
        // this.formData.item_category &&
        this.formData.email_list.length
      ) {
        payload = {
          website: this.selected_website,
          spider_name: this.formData.spiderName,
          time: this.formData.time,
          check: "spider",
          project: this.formData.projectType,
          index: this.formData.index,
          segment: this.formData.segment,
          item_category: this.formData.item_category,
          email_id: this.formData.email_list,
        };
      } else if (
        this.formData.scheduleType == "schedule_spider" &&
        this.formData.spiderName &&
        this.formData.time !== "00:00:00" &&
        this.formData.projectType === 'ecommerce_scrapy' &&
        this.formData.index &&
        this.formData.segment &&
        this.formData.item_category &&
        this.formData.email_list.length
      ) {
      } else if (
        this.formData.scheduleType == "schedule_spider" &&
        this.formData.spiderName &&
        this.formData.time !== "00:00:00" &&
        this.formData.projectType === 'demo_automation' &&
        this.formData.index &&
        this.formData.segment &&
        this.formData.item_category &&
        this.formData.email_list.length
      ) {
        console.log("time", this.formData.time)
        payload = {
          website: this.selected_website,
          spider_name: this.formData.spiderName,
          time: this.formData.time,
          check: "spider",
          project: this.formData.projectType,
          index: this.formData.index,
          segment: this.formData.segment,
          item_category: this.formData.item_category,
          email_id: this.formData.email_list,
        }
      } else if (
        this.formData.scheduleType == "schedule_local" &&
        this.formData.spiderName &&
        this.formData.index &&
        this.formData.segment &&
        this.formData.item_category &&
        this.formData.email_list.length
      ) {
        payload = {
          website: this.selected_website,
          spider_name: this.formData.spiderName,
          check: "local_spider",
          index: this.formData.index,
          segment: this.formData.segment,
          item_category: this.formData.item_category,
          email_id: this.formData.email_list,
        };
      } else if (
        this.formData.scheduleType == "schedule_dump" &&
        this.formData.time !== "00:00:00" &&
        this.formData.index &&
        this.formData.task &&
        this.formData.projectType
      ) {
        let fieldList = [];
        this.formData.fieldData.forEach((val) => {
          fieldList.push(val.code);
        });
        if (
          !fieldList.length &&
          (this.formData.task == "translate_category" ||
            this.formData.task == "translate_sov_details")
        ) {
          this.$bvToast.toast(`*Please fill all the required fields!!`, {
            autoHideDelay: 5000,
            variant: "danger",
          });
          return false;
        }
        payload = {
          website: this.selected_website,
          time: this.formData.time,
          check: "dump",
          index: this.formData.index,
          translate_fields: fieldList,
          task: this.formData.task,
          project: this.formData.projectType
        };
      } else {
        this.$bvToast.toast(`*Please fill all the required fields!!`, {
          autoHideDelay: 5000,
          variant: "danger",
        });
        return false;
      }
      this.$http.post(url, payload).then(
        (response) => {
          console.log(response.body.data);
          this.$bvToast.toast(`${response.body.data.data.msg}`, {
            autoHideDelay: 5000,
            variant: "success",
          });
          this.showForm = false;
          this.refresh();
        },
        (err) => {
          console.log(err);
        }
      );
    },
    submitSpiderConfigForm() {
      const url = "/api/spider/websitedetailupdate";
      const payload = {
        item_category: this.spiderConfigFormData.itemCategory,
        time: this.spiderConfigFormData.time, //hh:mm:ss
        website: this.spiderConfigFormData.website,
        segment: this.spiderConfigFormData.segment,
        translate_fields: this.spiderConfigFormData.translateFields,
        email_id: this.spiderConfigFormData.emailIDs,
        index: this.spiderConfigFormData.index,
        spider_name: this.spiderConfigFormData.spiderName,
        task: this.spiderConfigFormData.task,
        project: this.spiderConfigFormData.projectType
      };

      if (this.spiderConfigFormData.task === 'schedule_local') {
        delete payload['time']
      }

      this.$http.post(url, payload).then(
        (response) => {
          this.$bvToast.toast(`${response.body.data.data.msg}`, {
            autoHideDelay: 5000,
            variant: "success",
          });
          this.$nextTick(() => {
            this.showSpiderConfigForm = false;
            this.refresh();
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },
    submitDumpConfigForm() {
      const url = "/api/spider/dumpupdate";
      const translateFields = this.dumpConfigFormData.translateFields.map(
        (val) => val.code
      );
      const payload = {
        website: this.selected_website,
        index: this.dumpConfigFormData.index,
        task: this.dumpConfigFormData.task,
        time: this.dumpConfigFormData.time,
        project: this.dumpConfigFormData.projectType,
        translate_fields: translateFields,
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.$bvToast.toast(`${response.body.data.data.msg}`, {
            autoHideDelay: 5000,
            variant: "success",
          });
          this.$nextTick(() => {
            this.showDumpConfigForm = false;
            this.refresh();
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },

    validateEmail(email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    covertKebabCase(data) {
      const str = data.replace("_", " ");
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },

    deleteSpiderEmail(email, spider) {
      let self = this;
      self.loader = true;
      let payload = {
        email_id: email,
        spider: spider,
      };
      const url = "/api/spider/spider_email";
      self.$http.delete(url, { body: payload }).then(
        (response) => {
          self.loader = false;
          self.refresh();
        },
        (err) => {
          self.loader = false;
          console.log(err);
        }
      );
    },
    addNewEmail() {
      let self = this;
      if (!this.newEmail) {
        alert("Email Cant be empty");
        return false;
      }
      if (!this.validateEmail(this.newEmail)) {
        this.$bvToast.toast(`Invalid email address`, {
          autoHideDelay: 5000,
          variant: "danger",
        });
        return false;
      }

      self.loader = true;
      let payload = {
        email_id: this.newEmail,
        spider: this.selectedSpider,
      };
      const url = "/api/spider/spider_email";
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          this.newEmail = "";
          self.refresh();
        },
        (err) => {
          self.loader = false;
          console.log(err);
        }
      );
    },
    refresh() {
      (this.spiderTableData = {
        header: [],
        data: [],
      }),
        (this.dumpTableData = {
          header: [],
          data: [],
        }),
        this.getWebsiteDetailData();
    },
    deleteSpider(s) {
      let self = this;
      self.loader = true;
      let payload = {
        website: self.selected_website,
        spider: s,
      };
      const url = "/api/spider/spider_list";
      self.$http.delete(url, { body: payload }).then(
        (response) => {
          self.loader = false;
          self.refresh();
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    addNewSpider() {
      let self = this;
      if (!self.spiderTextNew) {
        alert("Spider Name Cant be empty");
        return false;
      }

      self.loader = true;
      let payload = {
        website: self.selected_website,
        spider_list: [self.spiderTextNew],
      };
      const url = "/api/spider/addspider";
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.spiderTextNew = "";
          self.refresh();
        },
        (err) => {
          self.loader = false;
          console.log(err);
        }
      );
    },

    getData() {
      let self = this;
      this.loader = true;
      let payload = {
        website: this.selected_website,
      };
      const url = "/api/spider/spider_list";
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.spiderData = response.body.data;
        },
        (err) => {
          self.loader = false;
          console.log(err);
        }
      );
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.top-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
}

.left-card {
  display: flex;
  justify-content: space-between;
  gap: 10px !important;
}

/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.card_vivo {
  background-color: #0072ba !important;
  border: 1px solid #0072ba !important;
}

.card_realme {
  background-color: #f3b821 !important;
  border: 1px solid #f3b821 !important;
}

.card_redmi {
  background-color: #f56628 !important;
  border: 1px solid #f56628 !important;
}

.badge {
  padding: 6px;
  font-size: 13px;
}

.redbg {
  background: #ffd1d1;
  color: inherit;
}

.ybg {
  background: #ffff9c;
  color: inherit;
}

.greenbg {
  color: green;
  cursor: pointer;
}

.highcharts-figure .chart-container {
  width: 300px;
  height: 200px;
  float: left;
}

.thead-normal th,
.tbody-normal td {
  border: 1px solid silver !important;
}

.thead-normal tr {
  background: rgb(138, 135, 232);
  color: white;
}

.saveBtn {
  background-color: #b4ffb3;
  border-radius: 0;
  height: 30px;
  border: none;
  width: 60px;
}

.form_button {
  margin-left: 1.5rem;
  height: 30px;
}

.crossIcon {
  cursor: pointer;
  font-size: 10px;
  height: 10px;
  color: gray;
}

.asinBadge {
  /* background: '#9683b3'; */
  background: "#9683b3";
  border-radius: 5px;
  font-size: 14px;
  height: 25px;
  font-weight: lighter;
}

.scroll-x {
  overflow-x: scroll;
}

.edit-buttons {
  border: none;
  font-size: 18px;
  background: none;
}

/* revamp */
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

select option {
  text-transform: capitalize !important;
  padding: 10px 0px !important;
}

select {
  font-family: "Poppins", sans-serif !important;
}

customSelect {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
}

.customSelect optgroup {
  color: var(--primary_brand);
}

.customSelect option {
  color: var(--primary_brand-60);
}

.customSelect:focus {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: 600 !important;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
  color: var(--primary_brand-80);
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
  border: none !important;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.badge-primary {
  background-color: var(--primary_brand-80);
}

@media (max-width: 600px) {
  .left-card {
    flex-direction: column !important;
  }

  .top-card {
    flex-direction: column;
  }
}
</style>
<style>
.vue__time-picker {
  width: 100% !important;
}

.vue__time-picker>input {
  width: 100% !important;
  border-radius: 4px !important;
  border: 1px solid silver !important;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
}

.modal-title {
  font-weight: 600 !important;
  font-family: "poppins" !important;
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color) !important;
  border: none !important;
  font-family: "poppins" !important;
  border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
  color: black !important;
  text-shadow: none !important;
  position: absolute !important;
  top: -2px !important;
  right: -6px !important;
  font-size: 30px !important;
  background: var(--primary_brand-10) !important;
  opacity: inherit !important;
  padding: 5px 10px !important;
  border-radius: 25px !important;
}
</style>
